// extracted by mini-css-extract-plugin
module.exports = {"button":"inlineToolbar__button___2QN1_","active":"inlineToolbar__active___3fetV"};